import { mapActions } from 'vuex';
import { MODALS } from '@/components/app/app-modals/modals-constants';

export default {
  props: {
    email: {
      type: String,
      required: false,
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup', 'setCurrentPopupOptions']),
    onLogin() {
      this.setCurrentPopup(MODALS.LOGIN);
      this.setCurrentPopupOptions({ email: this.email });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-already-exists/account-already-exists.js